export const home = {
  hero: {
    title1: 'プロフェッショナル映像機材',
    title2: 'レンタルサービス',
    title3: 'LensBank',
    subtitle: '国内外のプロフェッショナル映画人と長年協力してきた専門機材レンタルサービス',
    cta1: '今すぐレンタル',
    cta2: '撮影サービス'
  },
  services: {
    title: 'コアサービス',
    equipment: {
      title: 'プロ機材レンタル',
      desc: '1,000点以上のプロ撮影機材、あらゆる撮影ニーズに対応',
      badge: '1,000+ 機材'
    },
    taiwanJapan: {
      title: '台日撮影サービス',
      desc: '国境を越えた撮影の全面サポート、機材・チーム・場所をワンストップで'
    },
    urent: {
      title: 'Urent 寄託レンタル',
      desc: '遊休機材を収益化、専門保管とレンタル管理'
    },
    postProduction: {
      title: '日本編集・カラグレ',
      desc: 'ハイエンド広告レベルのポストプロダクション、プロチームの品質保証'
    },
    about: {
      title: 'LensBankについて',
      desc: '10年以上の専門経験、信頼できる映像制作パートナー'
    }
  },
  locations: {
    title: '店舗情報',
    viewAll: 'すべての店舗を見る',
    store: '店舗',
    warehouse: '倉庫',
    hours: '営業時間',
    address: '住所'
  },
  stats: {
    equipment: 'プロ機材',
    locations: 'サービス拠点',
    experience: 'サービス経験',
    clients: '協力クライアント'
  }
};